import React from 'react';
import Reflux from 'reflux';
import ReadOnlyStore from 'flux/stores/ReadOnlyStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import AlertBar from 'shared/components/misc/alertBar.jsx';

/**
 * Template Alert Bar
 *
 */
export default React.createClass({
  mixins: [
    Reflux.connectFilter(ReadOnlyStore, 'readOnly', (state) =>
      state.get('readOnly'),
    ),
    Reflux.connectFilter(CuesheetStore, 'show', (state) => state.get('show')),
  ],

  displayName: 'TemplateAlertBar',

  render() {
    if (!this._isVisible()) return null;

    return (
      <AlertBar
        type="warning"
        message="This is a custom template. Do not treat this as an active show."
        dismissible
        onDismiss={this._handleClose}
      />
    );
  },

  _handleClose() {
    this.setState({ hidden: true });
  },

  _isVisible() {
    let { show, readOnly, hidden } = this.state;

    if (!show) return false;

    return !readOnly && show.get('template') && !hidden ? true : false;
  },
});
